
  export default {
    props: {
      expandedByDefault: { type: Boolean, required: false, default: true },
      features: { type: Array, required: false, default: () => [] }
    },
    data () {
      return {
        expanded: false
      };
    },
    computed: {
      firstFeature () {
        return this.features.length > 0 ? this.features[0] : null;
      },
      hiddenFeaturesText () {
        const hiddenCount = Math.max(0, this.features.length - 1);
        return this.$tc('featureChip.more', hiddenCount);
      },
      slicedFeatures () {
        return this.features.slice(1);
      }
    },
    created () {
      this.expanded = this.expandedByDefault;
    }
  };
